function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85.248 4.207C75.541 5.259 66.541 9.96 60.27 17.12c-6.272 7.161-10.38 15.773-14.874 24.064-4.494 8.292-9.63 16.566-17.318 22.328-7.33 5.494-16.873 8.64-22.176 15.956-5.46 7.535-4.863 18.128-.014 26.033 4.85 7.904 13.324 13.32 22.357 16.393 9.032 3.07 18.687 4.022 28.244 4.757 31.02 2.377 63.034 2.552 92.276-7.624 10.521-3.662 21.2-9.24 26.189-18.823 4.963-9.536 3.12-21.334-2.344-30.619s-14.099-16.46-22.99-22.881c-8.894-6.421-18.279-12.336-26.056-19.965-5.477-5.375-10.127-11.57-16.282-16.224-6.163-4.653-12.885-7.3-22.034-6.31",
  fill: "#E3EFE8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.403 126.518c.055-15.025 4.29-30 12.01-42.447 7.716-12.447 18.88-22.312 32.648-27.359 1.525 15.338-2.28 31.238-10.487 43.805-8.207 12.568-20.744 21.686-34.171 26.001",
  fill: "#2B9D8B",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.579 60.802a229.722 229.722 0 0 0-38.547 63.231m30.345-53.154a25.126 25.126 0 0 1-.234-7.155m-4.005 12.953c3.948.593 7.972.665 11.939.209m-20.544 12.592a46.337 46.337 0 0 1-3.333-11.735m-.18 18.115a74.756 74.756 0 0 0 16.197 1.938m-22.2 8.769a41.636 41.636 0 0 1-4.402-10.413",
  stroke: "#ECF6F5",
  strokeWidth: 0.512,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.128 126.845c5.305-10.28 14.577-18.441 25.435-22.391 10.857-3.95 23.193-3.648 34.437 1.817-15.326 15.09-37.875 22.46-59.872 20.574",
  fill: "#2B9D8B",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.197 107.28c-18.453 1.869-36.462 8.018-52.216 17.828m40.596-16.155a26.063 26.063 0 0 1 3.031-5.137m-7.563 6.339a24.2 24.2 0 0 0 6.913 5.206m-16.36-2.587a22.77 22.77 0 0 1 1.997-8.986m-7.297 10.93a26.662 26.662 0 0 0 6.145 8.24m-13.636-5.318a25.724 25.724 0 0 1 .137-7.125m-5.646 9.964a16.948 16.948 0 0 0 7.24 3.785",
  stroke: "#ECF6F5",
  strokeWidth: 0.512,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.399 124.449c1.056-15.344 2.093-30.938-1.323-45.95C75.66 63.485 67.108 48.861 52.59 41.984c-5.906 15.11-9.546 31.672-5.958 47.458 3.585 15.787 15.742 30.474 33.768 35.007",
  fill: "#2B9D8B",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.058 47.066c2.712 10.248 5.423 20.498 8.136 30.746 4.013 15.173 8.067 30.454 14.917 44.572M64.247 52.732a55.85 55.85 0 0 1-4.9 10.475m1.69 6.51c-4.71.635-9.477.835-14.223.596m18.73 15.79a52.794 52.794 0 0 0 11.393-12.78m-9.042 21.952a32.424 32.424 0 0 1-14.703.654m19.564 14.154a34.757 34.757 0 0 0 7.308-10.02",
  stroke: "#ECF6F5",
  strokeWidth: 0.512,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.548 124.894C58.988 99.899 29.36 84.4 0 85.896c3.061 14.786 12.931 28.014 26.219 35.133 13.288 7.12 29.747 8.005 48.329 3.865",
  fill: "#2B9D8B",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.913 89.04c6.468 6.538 13.013 13.14 20.818 17.995 8.3 5.165 17.731 8.17 27.102 10.94a742.259 742.259 0 0 0 18.618 5.242M16.047 99.753a45.676 45.676 0 0 0 1.106-11.534m-4.417 8.601a28.691 28.691 0 0 1-6.1 2.518m12.585 15.91a34.697 34.697 0 0 0 9.459-6.407m7.346 3.408a92.071 92.071 0 0 0 1.108-16.776m21.369 12.452a44.884 44.884 0 0 1-1.138 11.336m-2.733-.656a19.31 19.31 0 0 1-7.54 6.605",
  stroke: "#ECF6F5",
  strokeWidth: 0.512,
  opacity: 0.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.599 92.418C83.929 92.682 75 62.427 75 62.427s5.14-.424 6.95-1.98c.59-.508 1.084-2.165 1.482-4.17.348-1.756.622-3.779.822-5.53.272-2.4.41-4.294.41-4.294l13.004-1.676s.291 4.005.667 7.927c.19 1.96.4 3.904.612 5.31.134.922.271 1.62.398 1.944.704 1.82 9.71 2.565 9.71 2.565S99.993 92.129 91.6 92.418z",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.945 58.018c-7.936 1.481-12.75-4.242-14.692-7.268.271-2.4.408-4.294.408-4.294l13.006-1.677s.29 4.005.666 7.928c.192 1.963.404 3.903.612 5.31M107.499 36.495c1.716-.561 3.347.846 3.643 3.144.295 2.298-.858 4.615-2.575 5.177-1.716.561-3.347-.846-3.642-3.144-.296-2.297.857-4.615 2.574-5.177",
  fill: "#C8795D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.605 35.744c.46-10.184 7.006-18.461 15.652-18.461 8.646 0 15.652 8.266 15.652 18.461 0 10.195-6.512 18.87-13.021 19.61-8.592.976-18.763-9-18.283-19.61",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.436 39.238c.877-2.202 3-8.634 4.817-11.463 0 0 7.81 2.438 11.532 2.095 4.63-.426 4.542-2.89 3.673-4.08l4.918 2.364 3.193 8.937-1.264-13.117-24.225-4.555-5.034 12.251",
  fill: "#C8795D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.683 31.31c-.29 4.19-1.18 8.937-1.18 8.937-.433-5.091-.847-9.226-2.115-12.972l-9.686-4.107s5.358 4.05 1.657 5.13c-3.794 1.107-13.611-2.436-13.611-2.436-1.309 2.295-3.517 11.047-4.08 15.096-.29 2.09-4.857-2.207-4.78-.566 0 0-5.407-14.558 2.164-23.106l.057-.064c3.687-4.126 8.811-5.58 15.148-5.319 10.353 0 15.186 7.178 16.25 14.583.23 1.622.283 3.252.176 4.824",
  fill: "#0E1427"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.505 26.486a22.759 22.759 0 0 0-6.433-7.807c-4.312-3.315-9.848-5.005-15.266-4.596a21.865 21.865 0 0 0-9.7 3.142c3.687-4.126 8.812-5.58 15.148-5.319 10.353-.003 15.184 7.175 16.25 14.58",
  fill: "#1F3152"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.954 37.297c2.045 0 3.703 1.901 3.703 4.247S82 45.791 79.954 45.791s-3.703-1.901-3.703-4.247 1.658-4.247 3.703-4.247M165.954 97.936s-32.374 25.298-39.63 26.19c-2.515.312-6.394-5.78-9.82-12.476-3.204-6.265-5.19-12.504-5.19-12.504l11.996-17.087 1.196-1.702.312.875c1.111 3.097 4.938 13.658 7.275 18.994.837 1.91 1.484 3.147 1.747 3.139 1.139-.038 25.912-10.204 25.912-10.204l6.202 4.775",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.15 95.72s3.659-10.945 4.657-12.52c.935-1.48 9.39-7.725 11.181-6.688 1.756 1.017-5.034 5.978-5.034 5.978s8.869-4.78 10.04-3.081c1.347 1.957-8.6 6.663-8.6 6.663s10.062-2.652 10.062-1.435c0 1.496-8.355 4.165-8.355 4.165s8.553-1.067 8.36.244c-.268 1.831-8.596 2.752-8.596 2.752s-1.122 7.73-6.156 8.444l-7.56-4.521",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.66 88.64a49.882 49.882 0 0 1 6.271-6.056c.313-.253.637-.506 1.02-.63.385-.123.84-.09 1.134.185.271.253.35.66.296 1.025-.058.366-.23.7-.409 1.025-.787 1.446-1.67 2.84-2.611 4.319.828 2.078.587 4.552-.631 6.426",
  stroke: "#C0544F",
  strokeWidth: 0.846,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.762 97.936s32.375 25.298 39.63 26.19c2.516.312 6.395-5.78 9.82-12.476 3.205-6.265 5.19-12.504 5.19-12.504L60.408 82.059l-1.196-1.702-.313.875c-1.11 3.097-4.937 13.658-7.274 18.994-.837 1.91-1.484 3.147-1.748 3.139-1.138-.038-25.911-10.204-25.911-10.204l-6.203 4.775",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.567 95.72S24.908 84.776 23.91 83.2c-.936-1.48-9.39-7.725-11.181-6.688-1.756 1.017 5.033 5.978 5.033 5.978s-8.868-4.78-10.04-3.081c-1.347 1.957 8.6 6.663 8.6 6.663S6.26 83.42 6.26 84.637c0 1.496 8.356 4.165 8.356 4.165s-8.553-1.067-8.361.244c.269 1.831 8.597 2.752 8.597 2.752s1.122 7.73 6.155 8.444l7.56-4.521",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.056 88.64a49.882 49.882 0 0 0-6.27-6.056c-.313-.253-.637-.506-1.021-.63-.384-.123-.84-.09-1.133.185-.271.253-.351.66-.296 1.025.057.366.23.7.409 1.025.787 1.446 1.67 2.84 2.611 4.319-.828 2.078-.587 4.552.63 6.426",
  stroke: "#C0544F",
  strokeWidth: 0.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m132.093 100.223-15.59 11.427c-3.203-6.265-5.19-12.504-5.19-12.504l11.997-17.087 1.506-.83c1.113 3.098 4.937 13.659 7.277 18.994",
  fill: "#C8795D",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "m103.37 75.899 5.689-13.552s7.176 2.279 10.375 6.784c3.198 4.506 13.504 29.32 13.504 29.32l-20.478 9.628-9.09-32.18M75.13 62.347s-7.177 2.279-10.375 6.784c-3.199 4.506-13.505 29.32-13.505 29.32l20.478 9.628 9.09-32.18-5.689-13.552z",
  fill: "#E15D29"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.66 88.64a49.882 49.882 0 0 1 6.271-6.056c.313-.253.637-.506 1.02-.63.385-.123.84-.09 1.134.185.271.253.35.66.296 1.025-.058.366-.23.7-.409 1.025-.787 1.446-1.67 2.84-2.611 4.319.828 2.078.587 4.552-.631 6.426",
  fill: "#DFA47A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.2 106.735c-.907 11.595-2.051 21.12-2.051 21.12L68.683 128s-.074-4.288-.788-10.575l49.306-10.69-10.21-32.796-10.475-2.726-4.21 1.595-6.558-1.357-6.702 2.488-2.636 8.672-4.96 21.177c-.981 2.874-1.638 5.013-1.97 6.416-.331 1.404-.86 3.811-1.585 7.221",
  fill: "#E15D29"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.76 72.922c5.767-.949 11.215.066 16.279 2.663-.286-1.006-.788-2.515-1.073-3.52-.088-.309-.181-.63-.4-.867-.324-.352-.843-.434-1.32-.48-4.32-.424-8.748.29-13.485 2.204M90.551 72.724c-4.666-2.42-10.487-2.458-15.079-.066a14.334 14.334 0 0 0-.81 3.6c4.708-2.591 10.131-3.867 15.889-3.534",
  fill: "#AA451C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.33 73.106c3.637-3.947 6.274-7.897 8.013-13.882 0 0 4.216-.756 5.711 2.18.628 1.234 3.404 12.535 3.404 12.535-5.319-2.633-11.137-2.433-17.128-.833M82.313 59.224s-3.944-1.039-5.5 2.243c-.73 1.543-2.567 13.472-2.567 13.472 5.195-3.691 11.976-3.886 17.081-1.825-4.471-4.48-7.615-8.785-9.014-13.89",
  fill: "#E3F3F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.795 48.36.163.055a.466.466 0 0 0-.163-.055",
  fill: "#EFA79F"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M146.5 19.999c7.456 0 13.5 6.044 13.5 13.5 0 7.455-6.044 13.498-13.5 13.498S133 40.954 133 33.498c0-7.455 6.044-13.5 13.5-13.5",
  fill: "#2B9D8B",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.605 29.939c3.276-5.157 8.878 1.597 8.878 1.597s5.918-6.045 8.878-1.597c3.577 5.38-9.029 12.059-9.029 12.059s-12.139-6.694-8.727-12.06",
  fill: "#E15D29"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FDF0F1",
  strokeWidth: 0.512,
  d: "M134 34.464h7.019l1.083-4.486 2.176 9.02 1.884-11 1.579 9.858 2.462-6.18 1.071 2.808H157"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M33.5 0C42.613 0 50 7.387 50 16.5c0 9.111-7.387 16.498-16.5 16.498S17 25.611 17 16.5C17 7.387 24.387 0 33.5 0",
  fill: "#2B9D8B",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 7v12.27a7.835 7.835 0 0 1-3.377 6.463l-4.218 2.896a2.05 2.05 0 0 1-1.405.356 2.056 2.056 0 0 1-.906-.323l-4.541-2.953A7.84 7.84 0 0 1 25 19.134V7h18",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 7v12.27a7.835 7.835 0 0 1-3.377 6.463l-4.218 2.896a2.05 2.05 0 0 1-1.405.356V7h9",
  fill: "#EADEDB"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E15D29",
  d: "M28 18.999h11v-3H28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E15D29",
  d: "M32 22.999h3v-11h-3z"
})));

function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.20a887d6.svg";
export { ForwardRef as ReactComponent };